export const notAvailableValue: string = 'N/A'
export const createLocationTitle = 'Create Location'
